import React, { useState } from 'react';
import { Icon } from '../../components/Icon';
// import { usePerson } from '../../hooks/usePersonas';
// import { useDebounce } from '../../hooks/useDebounce';
// import type { EmpleadoFilters } from '../../types/empleado';
// import { UserFormCard } from '../../components/UserFormCard';
import { Table } from './Table';
import { useFuncionario } from '../../hooks/useFuncionarios';
import type { FuncionarioFilters } from '../../types/funcionarios';

const defaultFilters: FuncionarioFilters = {
  name: '',
  area_id: ''
};

const Funcionarios: React.FC = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    // const [searchTerm, setSearchTerm] = useState('');
    const [filters, setFilters] = useState<FuncionarioFilters>(defaultFilters);
    // const [showFilters, setShowFilters] = useState(false);
    // const [personType] = useState("1");

    // const debouncedSearch = useDebounce(searchTerm, 300);
    // Parametros para agregar nuevo empleado
    // const [showUserForm, setShowUserForm] = useState(false);

    // const handleOpenForm = () => {
    //     setShowUserForm(prev => !prev);
    // };

    // const handleCloseForm = () => {
    //     setShowUserForm(false);
    // };

    const {
        data: users,
        loading,
        error,
        total,
        totalPages,
        refetch,
        // search,
        updating,
        // creating
    } = useFuncionario({
        page: currentPage,
        pageSize,
        ...filters
    });




    const handleFilterChange = (newFilters: Partial<FuncionarioFilters>) => {
        setFilters(prev => ({ ...prev, ...newFilters }));
    };

    // const clearFilters = () => {
    //   setFilters({});
    //   setSearchTerm('');
    //   setShowFilters(false);
    // };

    if (error) {
        return (
            <div className="space-y-6 animate-fade-in">
                <div className="flex items-center justify-between">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                        Gestión de Visitas
                    </h2>
                </div>
                <div className="card p-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800">
                    <div className="flex items-center">
                        <Icon name="alert-circle" className="w-5 h-5 text-red-500 mr-2" />
                        <span className="text-red-700 dark:text-red-300">
                            Error al cargar funcionarios: {error}
                        </span>
                    </div>
                    <button
                        onClick={refetch}
                        className="mt-3 btn-primary"
                    >
                        Reintentar
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-6 animate-fade-in">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
                <div>
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                        Funcionarios
                    </h2>
                    <p className="text-gray-600 dark:text-gray-400 mt-1">
                        {total} funcionarios encontrados
                    </p>
                </div>
            </div>

            {/* Filtros y búsqueda */}
            <div className="card mb-2 p-4">
                <div className="grid grid-cols-1 lg:grid-cols-2 space-y-2">
                    <div className='mx-1'>
                        <div className="relative">
                            <Icon name="search" className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                            <input
                                type="text"
                                placeholder="Buscar por nombre..."
                                value={filters.name || ''}
                            onChange={(e) => handleFilterChange({ name: e.target.value || undefined })}
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                            />
                        </div>
                    </div>
                    <div className='mx-1'>
                        <select
                            value={filters.area_id || ''}
                            onChange={(e) => handleFilterChange({ area_id: e.target.value || undefined })}
                            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                        >
                            <option value="">Todos</option>
                            <option value="1">Medios</option>
                            <option value="2">Intervención General</option>
                            
                        </select>
                    </div>
                    {/* <div className='flex flex-row'>
                        <button
                            onClick={handleSearchPage}
                            className={`flex items-center mx-2 ${Object.keys(filters).length > 0 ? 'w-1/2': 'w-full'} px-3 py-2 lg:py-1 border dark:hover:bg-gray-700 dark:bg-gray-600 dark:text-white border-gray-500 text-sm font-medium rounded-lg transition-colors`}
                        >
                            <Icon name="search" className="w-4 h-4 mr-1" />
                            Buscar
                        </button>
                        {Object.keys(filters).length > 0 && (
                            <button
                                onClick={clearFilters}
                                className="flex items-center mx-2 w-1/2 px-3 py-2 lg:py-1 border dark:hover:bg-gray-700 dark:bg-gray-600 dark:text-white border-gray-500 text-sm font-medium rounded-lg transition-colors"
                            >
                                <Icon name="x-circle" className="w-4 h-4 mr-1" />
                                Limpiar
                            </button>
                        )}
                    </div> */}

                </div>
            </div>


            {/* Tabla de empleados */}
            <Table
                data={users}
                loading={loading}
                currentPage={currentPage}
                totalPages={totalPages}
                pageSize={pageSize}
                total={total}
                onPageChange={setCurrentPage}
                onRefresh={refetch}
                updating={updating}
            />
        </div>
    );
};

export default Funcionarios;